/* Pill scroller: paging arrows + beige edge fades for horizontal pill rows.
   Attaches to every [data-pill-scroller-wrap] containing a [data-pill-scroller]
   scroll container. Fades/arrows show only on the side with more content and
   vanish entirely when the row doesn't overflow (e.g. wrapped desktop rows).
   Loaded (deferred) by more than one section on some templates — the
   per-wrapper init guard keeps listeners single. */
(function () {
  function initPillScroller(wrap) {
    if (wrap.dataset.pillScrollerInit) return;
    wrap.dataset.pillScrollerInit = 'true';

    var scroller = wrap.querySelector('[data-pill-scroller]');
    var prev = wrap.querySelector('.pill-scroller__arrow--prev');
    var next = wrap.querySelector('.pill-scroller__arrow--next');
    if (!scroller || !prev || !next) return;

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var canLeft = scroller.scrollLeft > 2;
      var canRight = scroller.scrollLeft < max - 2;
      wrap.classList.toggle('pill-scroller--can-left', canLeft);
      wrap.classList.toggle('pill-scroller--can-right', canRight);
      prev.hidden = !canLeft;
      next.hidden = !canRight;
    }

    function page(direction) {
      scroller.scrollBy({ left: direction * scroller.clientWidth * 0.7, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-pill-scroller-wrap]').forEach(initPillScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
